/**
 * Created by mkoehler on 03.07.17.
 */

export default class Collapse {
  constructor() {
    let _scope = this;
    this.collapses = document.getElementsByClassName('collapse');

    if (this.collapses.length) {
      for (let collapse of Array.from(this.collapses)) {
        _scope.init(collapse);
      }
    }
  }

  init (collapse) {
    let _scope = this,
      collapseHead = collapse.getElementsByClassName('collapse-head')[0],
      collapseContent = collapse.getElementsByClassName('collapse-content')[0];

    collapseHead.addEventListener('click', function() {
      _scope.handleCollapse(collapse, collapseContent);
    });
  }

  handleCollapse(collapse, collapseContent) {
    if(collapse.getAttribute('aria-expanded') === false || collapse.getAttribute('aria-expanded') === 'false') {
      let h = this.getCurrentContentHeight(collapseContent);

      setTimeout(function () {
        collapseContent.style.maxHeight = h + 'px';
        collapse.setAttribute('aria-expanded', true);
      }, 100);
    } else {
      collapse.setAttribute('aria-expanded', false);
      collapseContent.style.maxHeight = '';
    }
  }

  getCurrentContentHeight(content) {
    content.style.maxHeight = 'none';
    let height = parseInt(content.offsetHeight, 10);
    content.style.maxHeight = '0px';

    return height;
  }
}